import { Shield } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ProtegoIcon({ size = 'md', className }) {
  const sizes = {
    sm: { container: 'w-8 h-8 rounded-lg', icon: 'w-4 h-4' },
    md: { container: 'w-10 h-10 rounded-xl', icon: 'w-5 h-5' },
    lg: { container: 'w-16 h-16 rounded-2xl', icon: 'w-8 h-8' },
    xl: { container: 'w-20 h-20 rounded-2xl', icon: 'w-10 h-10' },
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className={cn(
      s.container,
      'relative flex items-center justify-center',
      'bg-[hsl(222,28%,10%)]',
      'border border-[hsl(188,100%,55%)/0.3]',
      'shadow-[0_0_20px_hsl(188,100%,55%/0.15),0_0_40px_hsl(264,92%,70%/0.1)]',
      className
    )} style={{
      background: 'linear-gradient(135deg, hsl(222 28% 10%) 0%, hsl(222 28% 14%) 100%)',
      boxShadow: '0 0 20px hsl(188 100% 55% / 0.12), 0 0 40px hsl(264 92% 70% / 0.08), inset 0 1px 0 hsl(188 100% 55% / 0.1)'
    }}>
      <Shield className={cn(s.icon, 'text-[hsl(188,100%,55%)]')} strokeWidth={1.5} />
    </div>
  );
}

export function ProtegoLogo({ size = 'md', showText = true, className }) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <ProtegoIcon size={size} />
      {showText && (
        <span className={cn(
          'font-semibold',
          size === 'sm' ? 'text-base' : size === 'lg' || size === 'xl' ? 'text-2xl' : 'text-xl'
        )}>
          <span className="grad-accent-text">Protego</span>
          <span className="text-muted-foreground ml-1">AI</span>
        </span>
      )}
    </div>
  );
}
